import {useState} from 'react';
import {Segment} from 'semantic-ui-react';
import VoicesList from './voices-list';
import VoiceSearch from './voice-search';
import PropTypes from 'prop-types';

function Voices(props) {
  const [selectedVoices, setSelectedVoices] = useState(props.voices);

  return (
    <Segment>
      <VoiceSearch
        allVoices={props.voices}
        selectedVoices={selectedVoices}
        setSelectedVoices={setSelectedVoices}
      />
      <VoicesList voices={selectedVoices}/>
    </Segment>
  );
}

VoicesList.propTypes = {
  voices: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Voices;
